import { useEffect, useState } from "react";
import { useLang } from "@/i18n";

export const CookieNotice = () => {
    const { t } = useLang();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("jdv-cookies")) setVisible(true);
    }, []);

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-notice"
            role="dialog"
            aria-label="Aviso de cookies"
            className="fixed z-[60] bottom-20 md:bottom-5 left-4 right-4 md:left-5 md:right-auto md:max-w-sm bg-ink/95 backdrop-blur-xl border border-gold/30 rounded-sm p-5 shadow-[0_0_30px_rgba(0,0,0,0.6)]"
        >
            <p className="text-xs text-cream/70 font-light leading-relaxed">
                {t("cookie.text")}{" "}
                <a href="/privacidad" className="text-gold-soft hover:text-gold underline decoration-gold/30 underline-offset-2 transition-colors duration-300">
                    {t("footer.privacy")}
                </a>
            </p>
            <button
                onClick={() => {
                    localStorage.setItem("jdv-cookies", "accepted");
                    setVisible(false);
                }}
                data-testid="cookie-accept-button"
                className="mt-4 w-full border border-gold/50 text-gold font-accent text-[10px] tracking-[0.22em] uppercase px-4 py-2.5 rounded-sm hover:bg-gold/10 transition-colors duration-300"
            >
                {t("cookie.accept")}
            </button>
        </div>
    );
};
